import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-e7ed7476")
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "px-[4px]" }
const _hoisted_3 = { class: "flex items-baseline" }
const _hoisted_4 = ["textContent"]
const _hoisted_5 = {
  key: 0,
  class: "mt-[16px] px-[4px] pb-[3px]"
}
const _hoisted_6 = { class: "flex items-baseline" }
const _hoisted_7 = ["textContent"]
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_10 = { class: "flex items-baseline" }
const _hoisted_11 = ["textContent"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "mt-1 flex" }
const _hoisted_14 = { class: "flex items-center rounded-lg border px-1 shadow-inner dark:border-gray-700" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "px-2" }, "minutes", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppSlippageForm = _resolveComponent("AppSlippageForm")!
  const _component_BalBtnGroup = _resolveComponent("BalBtnGroup")!
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalTooltip = _resolveComponent("BalTooltip")!
  const _component_BalPopover = _resolveComponent("BalPopover")!

  return (_openBlock(), _createBlock(_component_BalPopover, {
    onShow: _cache[4] || (_cache[4] = ($event: any) => (_ctx.open = true)),
    onHide: _cache[5] || (_cache[5] = ($event: any) => (_ctx.open = false))
  }, {
    activator: _withCtx(() => [
      _createElementVNode("button", {
        class: "icon-spin-anim settings-button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onActivatorClick && _ctx.onActivatorClick(...args)))
      }, [
        _createElementVNode("img", {
          src: _ctx.Picture,
          height: "24",
          class: "mr-[12px] mt-[12px]"
        }, null, 8, _hoisted_1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", {
            class: "mb-[12px] font-semibold leading-[20px]",
            textContent: _toDisplayString(_ctx.$t('slippageTolerance'))
          }, null, 8, _hoisted_4)
        ]),
        _createVNode(_component_AppSlippageForm, { class: "" })
      ]),
      (_ctx.isEIP1559SupportedNetwork)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", {
                class: "mb-[12px] font-semibold leading-[20px]",
                textContent: _toDisplayString(_ctx.$t('transactionType'))
              }, null, 8, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_BalBtnGroup, {
                modelValue: _ctx.ethereumTxType,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = ($event: any) => (_ctx.ethereumTxType = $event)),
                  _ctx.setEthereumTxType
                ],
                options: _ctx.ethereumTxTypeOptions
              }, null, 8, ["modelValue", "options", "onUpdate:modelValue"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isGassless && _ctx.context === _ctx.TradeSettingsContext.trade)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", {
                class: "mb-2 font-medium",
                textContent: _toDisplayString(_ctx.$t('transactionDeadline'))
              }, null, 8, _hoisted_11),
              _createVNode(_component_BalTooltip, null, {
                activator: _withCtx(() => [
                  _createVNode(_component_BalIcon, {
                    name: "info",
                    size: "xs",
                    class: "-mb-px ml-1 text-gray-400"
                  })
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    innerHTML: _ctx.$t('transactionDeadlineTooltip')
                  }, null, 8, _hoisted_12)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": [
                    _cache[2] || (_cache[2] = ($event: any) => (_ctx.appTransactionDeadline = $event)),
                    _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.setTransactionDeadline && _ctx.setTransactionDeadline(...args)))
                  ],
                  class: "w-8 bg-transparent text-right",
                  placeholder: "20",
                  type: "number",
                  step: "1",
                  min: "0"
                }, null, 512), [
                  [_vModelText, _ctx.appTransactionDeadline]
                ])
              ]),
              _hoisted_15
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}